import { useState } from "react";
import { Satellite, Map, Mountain } from "lucide-react";

const MAP_STYLES = [
  { id: "satellite-streets", label: "Satellite", style: "mapbox://styles/mapbox/satellite-streets-v12", icon: Satellite },
  { id: "streets", label: "Streets", style: "mapbox://styles/mapbox/streets-v12", icon: Map },
  { id: "outdoors", label: "Topo", style: "mapbox://styles/mapbox/outdoors-v12", icon: Mountain },
];

const MapStyleSwitcher = ({ mapRef, onStyleLoad }) => {
  const [activeStyle, setActiveStyle] = useState("satellite-streets");

  const switchStyle = (styleObj) => {
    if (!mapRef?.current || styleObj.id === activeStyle) return;
    setActiveStyle(styleObj.id);

    mapRef.current.setStyle(styleObj.style);

    // Re-add custom layers after style loads
    mapRef.current.once("style.load", () => {
      if (onStyleLoad) onStyleLoad();
    });
  };

  return (
    <div className="flex bg-white/95 backdrop-blur rounded-lg shadow-lg overflow-hidden border border-zinc-200" data-testid="map-style-switcher">
      {MAP_STYLES.map((s) => {
        const Icon = s.icon;
        const isActive = activeStyle === s.id;
        return (
          <button
            key={s.id}
            onClick={() => switchStyle(s)}
            className={`flex items-center gap-1.5 px-3 py-2 text-xs font-semibold transition-colors ${
              isActive
                ? "bg-[#00341d] text-white"
                : "text-zinc-600 hover:bg-zinc-100"
            }`}
            title={s.label}
            data-testid={`style-${s.id}`}
          >
            <Icon className="w-3.5 h-3.5" />
            {s.label}
          </button>
        );
      })}
    </div>
  );
};

export default MapStyleSwitcher;
